
import React, { useEffect, useState } from 'react';
import { URL } from '../../Redux/common/url';


function Founder() {
      const [productLists, setProductLists] = useState([]);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      fetchProductList();
    }, []);

    const fetchProductList = async () => {
      try {
        const response = await fetch(`${URL.API_BASE_URL}/publicApi/founderListPublic`);
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setProductLists(data?.founder || []);
        setLoading(false);
      } catch (error) {
        console.error("Fetch error:", error);
        setLoading(false);
      }
    };
  
    if (loading) return <p className="text-center py-5">Loading...</p>;
  return (
    <div>
           <div className="container-fluid my-3 px-4">
       {productLists.map((item, index) => (
          <div className="row d-flex align-items-center " key={index}>
           
            <div className="col-md-6 my-4">
              <h5 className="card-title fw-bold text-danger">{item.title}</h5>
              <h1 className="card-title fw-bold mt-3">{item.subheading}</h1>
              <p className='my-4'>{item.short_description}</p>
              {/* <Link to={about2.Link} className='btn btn-danger'>{about2.button}</Link> */}
            </div>
             <div className="col-md-6 my-4">
              <img className='w-100 h-auto rounded-4 product-img-out'  src={URL?.API_BASE_URL + item?.feature_image}
                                  alt={item.title} />
            </div>
          </div>
        ))}

      </div>
    </div>
  )
}

export default Founder